module.exports = __webpack_public_path__ + "static/media/send-blue-icon.ed341763.svg";